import { loadable } from 'react-lazily/loadable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TransactionFunctions, UserFunctions } from '../redux/actions/AppActionFunctions/AppActions';
const { MessageView } = loadable(() => import('../components/MessageView'));
const debug = process.env.REACT_APP_DEBUG && false;
const mapStateToProps = (state, ownProps) => {
    debug && console.log('MessageView own props', ownProps);
    return {
        messages: state.AppReducer.messages,
    };
};
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        init: (cognitoUser, userGroupRoles) => {
            debug && console.log('MessageView Container requested init', ownProps);
        },
        userFunctions: bindActionCreators(UserFunctions, dispatch),
        transactionFunctions: bindActionCreators(TransactionFunctions, dispatch),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(MessageView);
